/**
 * created by tian ruo jun
 primary
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";

export default class Primary extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn,
            disabled: props.disabled
        }
    }

    show (){
        this.setState({hideBtn:false, disabled: false});
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            this.state.hideBtn ? "" :
            <Button
                type={"primary"}
                disabled={this.state.disabled}
                style={{marginLeft: "12px"}}
                onClick={this.props.onClick}
            >
                {this.props.icon}
                {this.props.btnName}
            </Button>
        )
    }

}